import { BRAND, NAV_LINKS } from "@/lib/siteData";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
  };

  return (
    <footer
      className="bg-foreground text-background pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={BRAND.emblemUrl}
              alt={BRAND.name}
              className="h-16 w-auto"
            />
            <p className="mt-3 font-headings text-2xl text-background leading-tight">
              {BRAND.name}
            </p>
            <p className="mt-2 font-ui text-[11px] uppercase tracking-[0.22em] text-secondary">
              Weddings · Events · Functions
            </p>
            <p className="mt-6 font-body text-background/75 leading-relaxed max-w-md">
              A traditional Kalyana Mandira in Basavanagudi, hosting weddings, engagements,
              sacred thread ceremonies and family gatherings since decades.
            </p>
          </div>

          <div className="md:col-span-3">
            <p
              className="eyebrow"
              style={{ color: "hsl(var(--secondary))" }}
              data-testid="footer-explore-overline"
            >
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    type="button"
                    onClick={() => scrollTo(l.id)}
                    className="font-body text-background/85 hover:text-secondary transition-colors"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p
              className="eyebrow"
              style={{ color: "hsl(var(--secondary))" }}
            >
              Reach Us
            </p>
            <ul className="mt-5 space-y-3 font-body text-background/85">
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin size={16} className="mt-1 text-secondary" />
                <span>{BRAND.shortAddress}</span>
              </li>
              <li>
                <a
                  href={`tel:${BRAND.phoneRaw}`}
                  className="flex items-start gap-3 hover:text-secondary transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={16} className="mt-1 text-secondary" />
                  <span>{BRAND.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${BRAND.whatsappRaw}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 hover:text-secondary transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle size={16} className="mt-1 text-secondary" />
                  <span>{BRAND.whatsapp}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="flex items-start gap-3 hover:text-secondary transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={16} className="mt-1 text-secondary" />
                  <span>{BRAND.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-background/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-ui text-[11px] uppercase tracking-[0.22em] text-background/55">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="font-ui text-[11px] uppercase tracking-[0.22em] text-background/55">
            Basavanagudi · Gandhi Bazaar · Bengaluru
          </p>
        </div>
      </div>
    </footer>
  );
}
